var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"dialogwrapper"},[_c('div',{staticClass:"overlay"}),_c('v-card',{staticClass:"dialog"},[_c('v-card-title',[_vm._v("提示")]),_c('v-card-text',[_vm._v(" 您确定这么做吗？ ")]),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.ok}},[_vm._v("确定")]),_c('v-btn',{on:{"click":_vm.cancel}},[_vm._v("取消")])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }